export const environment = {
  production: false,
  backendBaseUrl:
    'https://order-management-api.apps.acc.compumark.com/order-management-api',
  license: {
    agGrid:
      'Using_this_{AG_Grid}_Enterprise_key_{AG-101917}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Clarivate_Analytics_(US)_LLC}_is_granted_a_{Multiple_Applications}_Developer_License_for_{5}_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_need_to_be_licensed_in_addition_to_the_ones_working_with_{AG_Grid}_Enterprise___This_key_has_been_granted_a_Deployment_License_Add-on_for_{2}_Production_Environments___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{16_July_2027}____[v3]_[01]_MTgxNTY5MjQwMDAwMA==e1f56c5b3a302fe6534c58d242fd7b1c',
  },
  mockData: false,
  oneTrust: {
    apiKey: '0253b910-4306-422b-ac3a-f9fb94674594',
    productionUrl: 'ordermanagement.apps.compumark.com',
  },
  pendo: {
    enabled: true,
    apiKey: 'd7e76d48-3dc1-4e76-7c5f-e908d1ad1824',
  },
  zendesk: {
    apiKey: 'fa9948ad-f530-4866-9bac-1e0df0528a40',
    environment: 'stable',
  },
  selectionToolUrl:
    'https://selection-tool.apps.acc.compumark.com/watch-results',
  selectionToolBaseUrl: 'https://selection-tool.apps.acc.compumark.com',
  homePageUrl: 'https://selection-tool.apps.acc.compumark.com/home',
  sharedResultsPageUrl:
    'https://selection-tool.apps.acc.compumark.com/shared-results',
};
